var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[_vm.type, 'p-16']},[_c('div',{staticClass:"flex"},[(_vm.isWarning)?_c('span',{staticClass:"icon-warning flex-inline justify-start text-2lg text-yellow-400 mr-12"}):_vm._e(),_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }